import OpenDataCarto from "./opendata-carto.js";

class EnedisCarto extends OpenDataCarto {

    constructor(types) {
        super(types);
        this.opacity = 1;
    }

    get baseUrl() {
        return "https://opendata.enedis.fr/data-fair/api/v1";
    }

    get geoField() {
        return "geometry";
    }

    getDataUrls(type) {
        const bounds = this.getMap().getBounds().toJSON();
        const zoom = this.getMap().getZoom();
        const tileCount = Math.pow(2, zoom);
        const longitudeToTileX = longitude => Math.floor((longitude + 180) / 360 * tileCount);
        const latitudeToTileY = latitude => {
            const limitedLatitude = Math.max(-85.05112878, Math.min(85.05112878, latitude));
            const latitudeRadians = limitedLatitude * Math.PI / 180;

            return Math.floor(
                (1 - Math.log(Math.tan(latitudeRadians) + 1 / Math.cos(latitudeRadians)) / Math.PI)
                / 2 * tileCount
            );
        };
        const minX = longitudeToTileX(bounds.west);
        const maxX = longitudeToTileX(bounds.east);
        const minY = latitudeToTileY(bounds.north);
        const maxY = latitudeToTileY(bounds.south);
        const urls = [];

        for (let x = minX; x <= maxX; x++) {
            for (let y = minY; y <= maxY; y++) {
                const xyz = encodeURIComponent(`${x},${y},${zoom}`);
                urls.push(
                    `${this.baseUrl}/datasets/${type}/lines` +
                    `?xyz=${xyz}&size=1000&sampling=max&select=geometry&format=geojson&count=false`
                );
            }
        }

        return urls;
    }

    async fetchGeoJson(type) {
        const featureById = new Map();
        const requests = this.getDataUrls(type).map(async url => {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText} (${url})`);
            }

            const featureCollection = await response.json();
            (featureCollection.features || []).forEach(feature => {
                const id = feature.id || JSON.stringify(feature.geometry);
                featureById.set(id, feature);
            });
        });

        await Promise.all(requests);

        return {
            type: 'FeatureCollection',
            features: Array.from(featureById.values()),
        };
    }
    
}

export default EnedisCarto;
